module.exports = __webpack_public_path__ + "img/steez2.eca12529.png";